'use client'

import { useState } from 'react'
import IframeResizer, { type IframeResizedData } from '@/components/IFrameResizer/IFrameResizer'
import { WidgetIframeProps } from '@/types/cms'
import styles from './iFrameDefault.module.scss'
import SectionTitle from '@/components/SectionTitle/SectionTitle'

const IFrameDefault = ({ item }: { item: WidgetIframeProps }) => {
  const [hidden, setHidden] = useState(true)
  const onResized = (data: IframeResizedData) => (parseInt(data.height) < 30 ? setHidden(true) : setHidden(false))
  return (
    <section className={hidden ? styles.hidden : styles.wrapper}>
      {item.model.fields.headline && !hidden && (
        <SectionTitle link={item.model?.fields?.link as any} title={item.model.fields.headline} />
      )}
      <IframeResizer src={item.model.fields.uri} onResized={onResized} height="20" />
    </section>
  )
}

export default IFrameDefault
